<template>
  <div>
  <v-row class="pt-2 pb-0">
      <v-item-group
        mandatory
        v-model="tapSelect"
        @change="searchFilterData(), page=1"
      >
        <!-- <v-container> -->
          <v-row class="pl-3 pr-3 pt-5 pb-5">
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }" >
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0 ma-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-format-list-bulleted</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ totalAll }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">คำร้องทั้งหมด</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FEF5E9' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 4px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#E9A016'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#E9A016' : '#FEF5E9' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-clock-time-four-outline</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #E9A016;">{{ approveRole == 'Admin' ? totalPending:totalWaiting }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">รออนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#EFF4FD' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#00B0FF'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#00B0FF' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-timelapse</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #00B0FF;">{{ totalPending }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">กำลังดำเนินการ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#ECF8EA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#58A144'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#58A144' : '#ECF8EA' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-check-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #58A144;">{{ totalApproved }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">อนุมัติแล้ว</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="auto" v-show="mode=='approve'">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#FBE5E4' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="250"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-3 mt-1" :color="active ? 'white' : '#D1392B'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#D1392B' : '#FBE5E4' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-close-circle-outline</v-icon>
                  </v-col>
                  <v-col cols="8" class="mt-0 pt-1" style="text-align: right; padding-right:25px">
                    <span style="font-weight: 500; font-size: 24px; color: #D1392B;">{{ totalRejected }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ไม่อนุมัติ</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        <!-- </v-container> -->
      </v-item-group>
  </v-row>
  <v-row class="pt-0">
    <!-- <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อพนักงาน</span>
      <v-autocomplete
        v-model="keywordEmployeeName"
        :items="itemUserName"
        item-text="employeeName"
        item-value="employeeName"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จากชื่อ-นามสกุลพนักงาน"
        no-data-text="ไม่พบข้อมูล"
        @change="searchFilterData(), page=1"
        @click:clear="keywordEmployeeName='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col> -->
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">หมายเลขคำร้อง</span>
      <!-- <v-text-field
        v-model="keywordRequestNo"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาหมายเลขคำร้อง"
        no-data-text="ไม่พบข้อมูล"
        v-on:keyup.enter="searchFilterData(), page=1"
        @click:clear="keywordRequestNo='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-text-field> -->
      <v-autocomplete
        v-model="reqOrgChartNo"
        :items="selectors.reqOrgChartNo"
        outlined
        placeholder="ทั้งหมด"
        no-data-text="ไม่พบข้อมูล"
        class="mt-2"
        dense
        clearable
        @change="searchFilterData()"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        right
        offset-y
        origin='left'
        tile
        z-index="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="button-color-outline head-search-button"
            style="width: 96px; height: 38px;"
            text
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-3">
          <v-row class="pt-3">
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">หมายเลขคำร้อง</span>
              <!-- <v-text-field
                v-model="keywordRequestNo"
                outlined
                dense
                clearable
                class="mt-2"
                placeholder="ค้นหาหมายเลขคำร้อง"
                no-data-text="ไม่พบข้อมูล"
                v-on:keyup.enter="searchFilterData(), page=1"
                @click:clear="keywordRequestNo='', searchFilterData(), page=1"
              >
              <template v-slot:append>
                <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
              </template>
              </v-text-field> -->
              <v-autocomplete
                v-model="reqOrgChartNo"
                :items="selectors.reqOrgChartNo"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">บริษัท</span>
              <v-autocomplete
                v-model="companyName"
                :items="selectors.companyName"
                item-text="companyName"
                item-value="companyName"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">ประเภทสายบังคับบัญชา</span>
              <v-autocomplete
                v-model="typeOrgChart"
                :items="selectors.typeOrgChart"
                item-text="companyName"
                item-value="companyName"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">ชื่อสายบังคับบัญชา</span>
              <v-autocomplete
                v-model="nameOrgChart"
                :items="selectors.nameOrgChart"
                item-text="companyName"
                item-value="companyName"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">ประเภทคำร้อง</span>
              <v-autocomplete
                v-model="requestType"
                :items="selectors.requestType"
                item-text="requestTypeTh"
                item-value="requestTypeEng"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              ></v-autocomplete>
              <!-- <v-autocomplete
                v-model="requestType"
                :items="selectors.requestType"
                item-text="requestTypeTh"
                item-value="requestTypeEng"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    color="#EFF4FD"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    close-icon="mdi-close"
                    label
                    filter
                    small
                    @click="data.select"
                    @click:close="removeChip(data.item)"
                    style="color: #999999;"
                  >
                    <span style="color: #3776E9;">{{ data.item.requestTypeTh }}</span>
                  </v-chip>
                </template>
              </v-autocomplete> -->
            </v-col>
          </v-row>
          <v-row class="d-flex">
            <v-spacer/>
            <v-btn
              class="button-color-outline head-search-button mr-2"
              outlined
              style="width: 60px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="button-color ml-2 mr-3"
              style="width: 94px;"
              dark
              @click="searchFilterData(), menu = false"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <v-spacer/>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  getselectReqOrgChartList
} from '@/API/API'
// import axios from 'axios'
export default {
  name: 'filter-workgroup',
  props: {
    mode: String
  },
  data () {
    return {
      tapData: ['', 'รออนุมัติ', 'กำลังดำเนินการ', 'อนุมัติแล้ว', 'ไม่อนุมัติ'],
      tapSelect: 0,
      keywordEmployeeName: '',
      keywordRequestNo: '',
      keywordPosition: [],
      keywordType: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      itemUserName: [],
      itemPosition: [],
      itemCompanyName: [],
      itemGroupCompanyName: [],
      itemRequestType: [],
      filterData: {
        reqEmployeeNo: '',
        employeeName: '',
        companyName: [],
        position: [],
        requestType: [],
        requestStatus: [],
        approveType: this.mode,
        limit: 50,
        page: 1
      },
      selectData: {
        companyName: [],
        requestType: [],
        status: [
          { value: 'pending', text: 'รอการอนุมัติ' },
          { value: 'approve', text: 'อนุมัติ' },
          { value: 'reject', text: 'ปฏิเสธอนุมัติ' }
        ],
        statusAct: [
          { value: 'pending', text: 'รอการรับทราบ' },
          { value: 'acknowledge', text: 'รับทราบ' }
        ]
      },
      menu: false,
      totalAll: 0,
      totalWaiting: 0,
      totalPending: 0,
      totalApproved: 0,
      totalRejected: 0,
      allowBtnApprove: false,
      allowBtnReject: false,
      textBtnOk: this.mode === 'approve' ? 'Approve' : 'Acknowledge',
      textBtnNO: this.mode === 'approve' ? 'Reject' : 'Unacknowledge',
      approveRole: localStorage.approveRole,
      selectors: [],
      reqOrgChartNo: '',
      companyName: '',
      typeOrgChart: '',
      nameOrgChart: '',
      requestType: '',
      status: ''
    }
  },
  watch: {
    menu: function () {
      if (!this.menu) {
      }
    }
  },
  computed: {
    // approveRole () { return localStorage.approveRole }
  },
  async created () {
    await this.getSelectData()
    await this.searchFilterData()
  },
  beforeDestroy () {
    EventBus.$off('manageStructureApproveSearch')
    EventBus.$off('updateTotal')
    // EventBus.$off('setApproveRole') // ปิด 20/04/66
  },
  mounted () {
    // EventBus.$on('getPosition', this.getSelectData)
    // EventBus.$on('selectPosition', this.getSelectValue)
    EventBus.$on('updateTotal', this.updateTotal)
    // EventBus.$on('setApproveRole', this.setApproveRole) // ปิด 20/04/66
  },
  methods: {
    async setApproveRole () {
      this.approveRole = localStorage.approveRole
      this.page = 1
      this.resetFilterData()
      await this.getSelectData()
      await this.searchFilterData()
    },
    updateTotal (value) {
      this.totalAll = value.totalAll
      this.totalPending = value.totalPending
      this.totalApproved = value.totalApproved
      this.totalRejected = value.totalRejected
      this.totalWaiting = value.totalWaiting
    },
    async getSelectData () {
      try {
        const res = await getselectReqOrgChartList({ role: localStorage.approveRole }, this.$store.state.token)
        if (res.success) {
          if (res.result) {
            this.selectors = res.result
          }
        }
      } catch (error) {
      } finally {
      }
    },
    resetFilterData () {
      this.reqOrgChartNo = ''
      this.companyName = ''
      this.typeOrgChart = ''
      this.nameOrgChart = ''
      this.requestType = ''
      this.status = ''
      this.filterData = {
        reqOrgChartNo: '',
        companyName: [''],
        typeOrgChart: [''],
        nameOrgChart: [''],
        requestType: [''],
        // status: [''],
        role: this.approveRole,
        limit: 50,
        page: 1
      }
      // this.searchFilterData(1, 15)
      EventBus.$emit('manageStructureApproveSearch', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        reqOrgChartNo: this.reqOrgChartNo,
        companyName: this.setObjFilter(this.companyName),
        typeOrgChart: this.setObjFilter(this.typeOrgChart),
        nameOrgChart: this.setObjFilter(this.nameOrgChart),
        requestType: this.setObjFilter(this.requestType),
        status: this.setObjFilter(this.tapData[this.tapSelect]),
        role: this.approveRole
      }
      EventBus.$emit('manageStructureApproveSearch', this.filterData)
    },
    setObjFilter (data) {
      return (typeof data === 'string') ? [data] : data
    },
    removeChip (item) {
      const index = this.keywordType.indexOf(item.requestTypeEng)
      if (index >= 0) this.keywordType.splice(index, 1)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
</style>
